'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModalInstance', 'support', '$security', '$scope', 'OperatorService', 'types', 'okveds', 'areases', 'operators', 'industries', 'operations',
                function($modalInstance, support, $security, $scope, OperatorService, types, okveds, areases, operators, industries, operations) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.editing = editing;
                    $scope.isShowEdit = isShowEdit;
                    $scope.uploadFile = uploadFile;
                    $scope.getOperatorDisplayName = OperatorService.getDisplayName;
                    $scope.isBetween = OperatorService.isBetween;
                    $scope.formState = {
                        isValid: false
                    }
                    $scope.types = types;
                    $scope.areases = areases;
                    $scope.okveds = okveds;
                    $scope.operators = operators;
                    $scope.industries = industries;
                    $scope.operations = operations;

                    $scope.tinymceOptions = {
                        plugins: [
                            'advlist autolink link lists charmap nonbreaking table paste textcolor'
                        ],
                        autoresize_top_margin: 5,
                        autoresize_bottom_margin: 5,
                        height: 200,
                        menubar: false,
                        toolbar: 'undo redo | styleselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link table | forecolor backcolor',
                    };

                    // инициализация
                    init();

                    // region Function

                    function init() {
                        $scope.edit = false;
                        $scope.support = angular.copy(support);
                    }

                    function ok() {
                        $modalInstance.close($scope.support);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    /**
                     * Редактировать
                     */
                    function editing() {
                        $scope.edit = true;
                    }

                    /**
                     * Отображать кнопку редактировать?
                     * @returns {boolean|*}
                     */
                    function isShowEdit() {
                        return !$scope.edit && $security.isAllowWrite('/support-measures');
                    }

                    const toBase64 = file => new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = error => reject(error);
                    });

                    async function uploadFile(file) {
                        if (file && file.type === 'application/pdf') {
                            $scope.support.filename = file.name;
                           $scope.support.attachment = await toBase64(file);
                        } else {
                            $scope.support.attachment = null;
                            $scope.support.filename = '';
                        }
                    }

                    function validate(scope) {
                        $scope.formState.isValid = Boolean(scope.support.name && scope.support.supportType && scope.support.okved.length && scope.support.industry.length);
                    }

                    $scope.$watchGroup(['support.name', 'support.okved', 'support.supportType'], function(_n, _o, scope) {
                        validate(scope);
                    }, true);

                    $scope.$watchCollection('support.industry', function(_n, _o, scope) {
                        validate(scope);
                    });
                    // endregion
                }];
